export default {
  // uri: 'http://localhost:4443/api/',
  uri: 'https://test.wicon.io/api/',
  version: '1.0.1',
}
